import { cmsApi } from '@zet/cms-network'
import { zetApi } from '@zet/network'
import { getTagType } from '@zet/utils/loginHash'

import {
  BasicDetailsRequest,
  EmploymentDetailsRequest,
  GetCiterialIndexesRequest,
  GetPrefilledDataRequest,
  IAgentBanner,
  IAgentBannerResponse,
  IAgentDetailsResponse,
  IBasicDetailsResponse,
  IEmploymentDetailsResponse,
  IGetCiterialIndexesResponse,
  IGetPrefilledDataResponse,
  IOtpResponse,
  IZetCashMarketplaceBannerData,
  IZetCashMarketplaceBannerResponse,
  IVerifyOtpResponse,
  OtpRequest,
  VerifyOtpRequest,
} from '../../types'

export async function getAgentDetailsWF() {
  const tagType = getTagType()
  const { data } = await zetApi.get<IAgentDetailsResponse>(
    `public/customer/getAgentDetails/v2${tagType ? `?tag=${tagType}` : ''}`,
  )
  return {
    ...data?.data,
    ...(data.data.onecodeId ? { id: Number(data.data.onecodeId) } : {}),
  }
}

export async function getOtpToAddCustomer(suppliedData: OtpRequest) {
  zetApi.defaults.headers.common = {
    ...zetApi.defaults.headers.common,
    hash:
      sessionStorage.getItem('hash') || encodeURIComponent(suppliedData?.hash),
  }
  const { data } = await zetApi.post<IOtpResponse>(
    'customer/addCustomerOtp/v2',
    {
      fullName: suppliedData?.fullName,
      phoneNumber: suppliedData?.phoneNumber,
    },
  )
  return data?.data
}

export async function verifyOtpToAddCustomer(suppliedData: VerifyOtpRequest) {
  zetApi.defaults.headers.common = {
    ...zetApi.defaults.headers.common,
    hash: sessionStorage.getItem('hash') || suppliedData?.hash,
  }
  const { data } = await zetApi.post<IVerifyOtpResponse>(
    'customer/otp/verify',
    {
      customerId: suppliedData?.customerId,
      otp: suppliedData?.otp,
      phoneNumber: suppliedData?.phoneNumber,
    },
  )
  return data
}

export async function addBasicDetailsToAddCustomer(
  suppliedData: BasicDetailsRequest,
) {
  const { data } = await zetApi.post<IBasicDetailsResponse>(
    'customer/details/basic',
    {
      panNo: suppliedData?.panNo,
      customerId: suppliedData?.customerId,
      modeOfIncome: suppliedData?.modeOfIncome,
      dob: suppliedData?.dob,
      pinCode: suppliedData?.pinCode,
      email: suppliedData?.email,
      gender: suppliedData?.gender,
    },
  )
  return data
}

export async function getPrefilledData(suppliedData: GetPrefilledDataRequest) {
  const { data } = await zetApi.get<IGetPrefilledDataResponse>(
    `customer/getCustomerPrefillDetails?customerId=${suppliedData?.customerId}`,
  )
  return data?.data
}

export async function getCriteriaIndexes(
  suppliedData: GetCiterialIndexesRequest,
) {
  const { data } = await zetApi.get<IGetCiterialIndexesResponse>(
    `customer/getCriterialIndexes?locale=${suppliedData?.locale}`,
  )
  return data
}

export async function addEmploymentDetails(
  suppliedData: EmploymentDetailsRequest,
) {
  zetApi.defaults.headers.common = {
    ...zetApi.defaults.headers.common,
    hash: sessionStorage.getItem('hash') || suppliedData?.hash,
  }
  const { data } = await zetApi.post<IEmploymentDetailsResponse>(
    'customer/details/employment',
    {
      employmentType: suppliedData?.employmentType,
      currentOccupation: suppliedData?.currentOccupation,
      annualIncome: suppliedData?.annualIncome,
      bankNameList: suppliedData?.bankName,
    },
  )
  return data?.data
}

export async function getAgentBanner({ onecode }: IAgentBanner) {
  const { data } = await cmsApi.get<IAgentBannerResponse>(
    `cms/api/zetpro-banners?onecode=${onecode}`,
    {
      headers: {
        Authorization: null,
      },
    },
  )
  return data?.data
}

export async function getZetCashMarketplaceBanner({ onecode }: IAgentBanner) {
  const { data } = await cmsApi.get<IZetCashMarketplaceBannerResponse>(
    `cms/api/zet-cash-marketplaces?onecode=${onecode}`,
    {
      headers: {
        Authorization: null,
      },
    },
  )

  const bannerData = data?.data?.[0] as
    | IZetCashMarketplaceBannerData
    | undefined

  if (!bannerData) {
    return bannerData
  }

  return {
    ...bannerData,
    imageUrl: bannerData.bannerUrl,
  }
}
